<div class="skeleton" [attr.role]="role()" [attr.aria-busy]="ariaBusy()" [attr.aria-hidden]="ariaHidden()">
  @if (announce()) {
    <span class="is-vishidden">{{ loadingMessage() }}</span>
  }

  <ng-content></ng-content>
</div>
